/**
 * Get formulation ingredients from the server.
 */
const getFormulationIngredients = ( stateData ) => {
  const quizQuestions = {
    'disclaimer': 'Disclaimer',
    'chooseHowYoudLikeToFormulateYourPreworkout': 'Choose how you\'d like to formulate your pre-workout.',
    'whatShouldWeCallYou': 'What should we call you?',
    'howOldAreYou': 'How old are you?',
    'whatsYourSex': 'What\'s your sex?',
    'whatTypesOfExerciseWillYouUseYourPreworkoutFor': 'What types of exercise will you use your pre-workout for?',
    'howOftenWillYouUseYourPreworkout': 'How often will you use your pre-workout?',
    'whatAreYourCurrentWeightGoals': 'What are your current weight goals?',
    'whichOfTheFollowingOutcomesAreYouMostLookingForFromYourPreworkout': 'Which of the following outcomes are you most looking for from your pre-workout?',
    'doYouWantAStimulantcontainingPreworkout': 'Do you want a stimulant-containing pre-workout?',
    'howMuchDoYouWeigh': 'How much do you weigh?',
    'doYouHaveMuchExperienceWithCaffeinecontainingPreworkoutProducts': 'Do you have much experience with caffeine-containing pre-workout products?',
    'howOftenDoYouConsumeCaffeine': 'How often do you consume caffeine?',
    'doYouExperienceNegativeSideEffectsWhenUsingCaffeine': 'Do you experience negative side effects when using caffeine?',
    'willYouUseYourPreworkoutCloseToBedtime': 'Will you use your pre-workout close to bedtime?',
  };

  // Set up the quiz data.
  let quizData = {};

  // Get the quiz data from the state.
  for (const [stateKey, stateValue ] of Object.entries(stateData)) {
    if (quizQuestions[stateKey] !== undefined) {
      quizData[quizQuestions[stateKey]] = stateValue;
    }
  }

  try {
    console.log('About to make initial fetch request with body:', quizData);
    const request = new XMLHttpRequest();
    request.open('POST', '/wp-json/quiz/get-supplement-recommended-formula', false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(quizData));

    if (request.readyState === 4 && request.status === 200) {
      const json = JSON.parse(request.responseText);

      console.log('Response from initial fetch:', json);

      const { success, data = {} } = json;

      let ingredientGroups = [
        {
          heading: 'Base ingredients',
          className: 'base-ingredients',
          ingredients: [],
        },
        {
          heading: 'Stimulant ingredients',
          className: 'stimulant-ingredients',
          ingredients: [],
        },
        {
          heading: 'Optional ingredients',
          className: 'optional-ingredients',
          ingredients: [],
        }
      ];

      /*
        RESPONSE DATA STRUCTURE

        {
          "explanation": <string>,
          "recommendedFormula": {
            "baseIngredients": [
              {
                "ingredientAllowableDosageValues": [ <float>, <float> ],
                "ingredientDosageEditable": "yes|no",
                "ingredientDosageExplanation": <string>,
                "ingredientDosageUnits": <string>,
                "ingredientInclusionExplanation": <string>,
                "ingredientName": <string>,
                "ingredientRecommendedDosageValue": <float>,
                "ingredientRemovable": "yes|no",
              },
              ...,
            ],
            "stimulantIngredients": [
              {
                "ingredientAllowableDosageValues": [ <float>, <float> ],
                "ingredientDosageEditable": "yes|no",
                "ingredientDosageExplanation": <string>,
                "ingredientDosageUnits": <string>,
                "ingredientInclusionExplanation": <string>,
                "ingredientName": <string>,
                "ingredientRecommendedDosageValue": <float>,
                "ingredientRemovable": "yes|no",
              },
              ...,
            ],
            "optionalIngredients": [
              {
                "ingredientAllowableDosageValues": [ <float>, <float> ],
                "ingredientDosageEditable": "yes|no",
                "ingredientDosageExplanation": <string>,
                "ingredientDosageUnits": <string>,
                "ingredientInclusionExplanation": <string>,
                "ingredientName": <string>,
                "ingredientRecommendedDosageValue": <float>,
                "ingredientRemovable": "yes|no",
              },
              ...,
            ],
          },
          "status": "successful|unsuccessful",
        }
       */

      if (success && data.status === 'successful' && data.recommendedFormula) {
        ingredientGroups[0].ingredients = (data.recommendedFormula.baseIngredients.length > 0) ? data.recommendedFormula.baseIngredients : [];
        ingredientGroups[1].ingredients = (data.recommendedFormula.stimulantIngredients.length > 0) ? data.recommendedFormula.stimulantIngredients : [];
        ingredientGroups[2].ingredients = (data.recommendedFormula.optionalIngredients.length > 0) ? data.recommendedFormula.optionalIngredients : [];

        // Override the recommended dosage values for ingredients with the first allowable dosage value.
        ingredientGroups.forEach((ingredientGroup) => {
          let group = '';
          switch (ingredientGroup.heading) {
            case 'Base ingredients':
              group = 'base';
              break;
            case 'Stimulant ingredients':
              group = 'stimulant';
              break;
            case 'Optional ingredients':
            default:
              group = 'optional';
              break;
          }

          ingredientGroup.ingredients.forEach((ingredient, index) => {
            ingredientGroup.ingredients[index].ingredientType = group;
            ingredientGroup.ingredients[index].ingredientRemovedByDefault = 'no';
            ingredientGroup.ingredients[index].ingredientAllowableDosageValues =  ingredient.ingredientAllowableDosageValues.filter((x) => (parseFloat(x) !== 0.000 ));
            if (parseFloat(ingredient.ingredientRecommendedDosageValue) <= 0.00) {
              ingredientGroup.ingredients[index].ingredientRecommendedDosageValue = ingredient.ingredientAllowableDosageValues[0];
              ingredientGroup.ingredients[index].ingredientRemovedByDefault = 'yes';
            }
          });
        });

        return ingredientGroups;
      }
    } else if (data.explanation) {
      console.error('Error encountered:', data.explanation);

      return [];
    }
  } catch (error) {
    console.error('Error encountered:', error);

    return [];
  }
};

export default getFormulationIngredients;
